import { doc, getDoc, setDoc } from 'firebase/firestore';
import { UserRepository } from '../../../domain/contracts/repositories';
import { User } from '../../../domain/entities';
import db from '../../../setup/firebase/firebase';
import { FirebaseUser } from '../entities';
import { UserMapper } from '../mappers/user.mapper';

export class FirebaseUserRepository implements UserRepository {
  COLLECTION_PATH = 'users';

  async findOne(id: string): Promise<User> {
    const docRef = doc(db, this.COLLECTION_PATH, id);
    const user = (await getDoc(docRef)).data() as FirebaseUser;
    return UserMapper.toDomain(user);
  }

  async create(user: User): Promise<void> {
    await setDoc(doc(db, this.COLLECTION_PATH, user.id), {
      email: user.email,
      name: user.name,
      role: user.role
    });
  }
}
